export default "__VITE_ASSET__D77KFZ0y__"